import { Link } from "react-router-dom";
import { Twitter, Linkedin, Facebook, Instagram } from "lucide-react";
import { useTheme } from "./theme-provider";

export function Footer() {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  
  return (
    <footer style={{ 
      borderTopColor: isDarkMode ? '#374151' : '#e5e7eb', 
      borderTopWidth: '1px', 
      borderTopStyle: 'solid',
      background: isDarkMode ? '#0F172A' : 'white'
    }}>
      <div className="mx-auto max-w-7xl px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Copyright - Mobile: Bottom, Desktop: Left */}
          <div className="flex items-center text-sm order-4 md:order-1" style={{ color: isDarkMode ? '#9CA3AF' : '#4B5563' }}>
            <Link to="/auth" className="pr-1 hover:text-gray-800" style={{ color: isDarkMode ? '#9CA3AF' : '#4B5563' }}>
              ©
            </Link>
            <span>{new Date().getFullYear()} Sentiri Ltd. All rights reserved.</span>
          </div>

          {/* Right side container */}
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8 order-1 md:order-2">
            {/* Social Media Icons - Mobile: Top */}
            <div className="flex items-center space-x-6 order-1 md:order-2">
              <a href="https://x.com/Sentiriuk" target="_blank" rel="noopener noreferrer" className="transition-colors hover:!text-[#00DC82]" style={{ color: isDarkMode ? '#F3F4F6' : '#374151' }}>
                <Twitter className="h-6 w-6 md:h-5 md:w-5" />
              </a>
              <a href="https://www.linkedin.com/company/sentiri" target="_blank" rel="noopener noreferrer" className="transition-colors hover:!text-[#00DC82]" style={{ color: isDarkMode ? '#F3F4F6' : '#374151' }}>
                <Linkedin className="h-6 w-6 md:h-5 md:w-5" />
              </a>
              <a href="https://www.facebook.com/share/1WFwJRjDue/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="transition-colors hover:!text-[#00DC82]" style={{ color: isDarkMode ? '#F3F4F6' : '#374151' }}>
                <Facebook className="h-6 w-6 md:h-5 md:w-5" />
              </a>
              <a href="https://www.instagram.com/sentiriuk/" target="_blank" rel="noopener noreferrer" className="transition-colors hover:!text-[#00DC82]" style={{ color: isDarkMode ? '#F3F4F6' : '#374151' }}>
                <Instagram className="h-6 w-6 md:h-5 md:w-5" />
              </a>
            </div>

            {/* Legal Links */}
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 order-2 md:order-1">
            <Link 
                to="/privacy" 
                className="transition-colors hover:!text-[#00DC82] text-sm order-2 md:order-none" 
                style={{ color: isDarkMode ? '#F3F4F6' : '#374151' }}
              >
                Privacy Policy
              </Link>
              
              <Link 
                to="/terms" 
                className="transition-colors hover:!text-[#00DC82] text-sm order-3 md:order-none" 
                style={{ color: isDarkMode ? '#F3F4F6' : '#374151' }}
              >
                Terms and Conditions
              </Link>
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}